import { render, staticRenderFns } from "./cadformaspagamento.vue?vue&type=template&id=5e4670e1&"
import script from "./cadformaspagamento.vue?vue&type=script&lang=js&"
export * from "./cadformaspagamento.vue?vue&type=script&lang=js&"
import style0 from "./cadformaspagamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports